import { useEffect } from 'react';

/**
 * Handles the /baseline-security route.
 * Navigates to /baseline-security/ served by the auth gateway (same-origin).
 */
export default function BaselineSecurityRedirect() {
  useEffect(() => {
    window.location.replace('/baseline-security/');
  }, []);

  return null;
}
